import { observable } from 'mobx';
import { useEffect } from 'react';
import useMount from '@src/utils/hooks/use-mount';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import vhCheck from 'vh-check';
import getRemScale from '@src/utils/get-rem-scale';
const pageLocalesData = getPageLocalesData();
const textInfo = pageLocalesData.main.sixSection;

class SixSectionStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  // 是否激活
  @observable isActive = false;
  // 版本切换的索引
  @observable currentIndex = 0;

  @observable
  versionList = [
    {
      id: '',
      title: textInfo[0].name,
      info: textInfo[0].info,
      bgImgs: require('./images/A.jpg'),
      tabCoverImgs: require('./images/tab/A.png')
    },
    {
      id: '',
      title: textInfo[1].name,
      info: textInfo[1].info,
      bgImgs: require('./images/B.jpg'),
      tabCoverImgs: require('./images/tab/B.png')
    },
    {
      id: '',
      title: textInfo[2].name,
      info: textInfo[2].info,
      bgImgs: require('./images/C.jpg'),
      tabCoverImgs: require('./images/tab/C.png')
    },
    {
      id: '',
      title: textInfo[3].name,
      info: textInfo[3].info,
      bgImgs: require('./images/D.jpg'),
      tabCoverImgs: require('./images/tab/D.png')
    },
    {
      id: '',
      title: textInfo[4].name,
      info: textInfo[4].info,
      bgImgs: require('./images/E.jpg'),
      tabCoverImgs: require('./images/tab/E.png')
    }
  ];

  versionSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      autoplay: {
        disableOnInteraction: false,
        delay: 5000
      },
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      }
    }
  });

  versionTabSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      slidesPerView: 3,
      centeredSlides: true,
      spaceBetween: 20
      // loopedSlides: 3
    }
  });

  use() {
    useMount(async () => {});
    useEffect(() => {
      try {
        const vhCheckResult = vhCheck();
        const remScale = getRemScale();
        this.vhOffset = (vhCheckResult?.offset || 0) * remScale;
      } catch (e) {
        console.error(e);
      }
    }, []);
    useEffect(
      () => {
        this.currentIndex = this.versionTabSwiper.activeIndex;
        this.versionSwiper.activeIndex = this.versionTabSwiper.activeIndex;
      },
      [this.versionTabSwiper.activeIndex]
    );
    useEffect(
      () => {
        this.versionTabSwiper.activeIndex = this.versionSwiper.activeIndex;
        this.currentIndex = this.versionSwiper.activeIndex;
      },
      [this.versionSwiper.activeIndex]
    );
    useEffect(
      () => {
        this.versionSwiper.activeIndex = this.currentIndex;
        this.versionTabSwiper.activeIndex = this.currentIndex;
      },
      [this.currentIndex]
    );
  }
}

export default SixSectionStore;
